import React from 'react';
import { Flex, Text } from '@applyboard/crystal-ui';
import { formatScholarshipAmount } from "../utils";
import { SectionTitle } from "./SectionTitle";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var AmountSection = function AmountSection(_ref) {
  var amountFrom = _ref.amountFrom,
    amountTo = _ref.amountTo,
    currencySymbol = _ref.currencySymbol,
    currencyCode = _ref.currencyCode,
    amountType = _ref.amountType;
  var amountRange = formatScholarshipAmount({
    amountFrom: amountFrom,
    amountTo: amountTo,
    currencySymbol: currencySymbol,
    currencyCode: currencyCode,
    amountType: amountType
  });
  return _jsxs(Flex, {
    direction: "column",
    gap: 1,
    children: [_jsx(SectionTitle, {
      title: "Amount"
    }), _jsx(Text, {
      children: amountRange
    })]
  });
};